import React, { useState, useEffect } from 'react';

import APIError from 'components/AlertScreens/APIError';
import TableSkeletonLoader from 'components/AlertScreens/TableSkeletonLoader';
import { useSelector, shallowEqual } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import PreviewAlert from 'screens/admin/common/TemplateCommons/PreviewAlert';
import { ReviewProvider } from 'screens/performanceReview/ReviewContext';
import ReviewForm from 'screens/performanceReview/components/ReviewForms';
import { selectLoggedInEmployeeId } from 'selectors/loggedInEmployee';
import styled from 'styled-components';

import { REVIEW_QUESTION_TYPE_MAP_2 } from 'constants/ProjectConstants';
import { getQueryParams } from 'constants/helper';

import { getTemplateStructure } from 'services/templates/review';

import { useReviewTemplate } from '../common/ReviewTemplateContext';

const LOADING_STATUS = {
  LOADING: 'LOADING',
  LOADED: 'LOADED',
  ERROR: 'ERROR',
};

const ALL_FORM_NAMES = [
  {
    formName: 'GOAL',
    status: 'NOT_STARTED',
    totalQuestions: 0,
    unansweredQuestions: 0,
  },
  {
    formName: 'COMPETENCY',
    status: 'NOT_STARTED',
    totalQuestions: 0,
    unansweredQuestions: 0,
  },
  {
    formName: 'QNA',
    status: 'NOT_STARTED',
    totalQuestions: 0,
    unansweredQuestions: 0,
  },
];

const getFormObjectArray = (reviewForms) => {
  const formObjectArray = [];
  Object.keys(reviewForms).forEach((formName) => {
    if (reviewForms[formName] !== null && reviewForms[formName] !== undefined) {
      formObjectArray.push(formName);
    }
  });
  return formObjectArray
    .map((form) => ALL_FORM_NAMES.filter((item) => item.formName === REVIEW_QUESTION_TYPE_MAP_2[form])[0])
    .filter((item) => item !== undefined);
};

const ReviewTemplatePreview = () => {
  const location = useLocation();
  const {
    state: { META },
    setMeta,
  } = useReviewTemplate();

  const queryParams = getQueryParams(location.search);
  const autoNavigateQueryParam = Boolean(queryParams?.autoNavigate);

  const [reviewForms, setReviewForms] = useState(null);
  const [isManagerView, setManagerView] = useState(false);
  const [isShowGoalWeightage, setisShowGoalWeightage] = useState(true);
  const [isShowGoalRating, setIsShowGoalRating] = useState(false);
  const [autoNavigate, setAutoNavigate] = useState(autoNavigateQueryParam);
  const [isGoalSectionEditable, setIsGoalSectionEditable] = useState(true);
  const [loading, setLoading] = useState(null);

  const { templateId } = useParams();
  const loggedInEmployeeId = useSelector(selectLoggedInEmployeeId, shallowEqual);

  const fetchMeta = () => {
    setLoading(LOADING_STATUS.LOADING);
    getTemplateStructure({ templateId })
      .then((res) => {
        setMeta({ meta: res });
        setReviewForms(getFormObjectArray(res.templateSetting.overallRatingDistribution));
        setLoading(LOADING_STATUS.LOADED);
      })
      .catch((err) => {
        setLoading(LOADING_STATUS.ERROR);
        console.log(err);
      });
  };
  console.log('META: ', META);
  useEffect(() => {
    templateId && fetchMeta();
  }, []);

  return LOADING_STATUS.ERROR === loading ? (
    <APIError />
  ) : LOADING_STATUS.LOADING === loading ? (
    <TableSkeletonLoader />
  ) : LOADING_STATUS.LOADED === loading ? (
    <ReviewProvider>
      <PreviewAlert />
      <Container>
        <ReviewForm
          employeeId={loggedInEmployeeId}
          isPreview
          availableReviewForms={reviewForms}
          isManagerView={isManagerView}
          isShowGoalWeightage={isShowGoalWeightage}
          isShowGoalRating={isShowGoalRating}
          autoNavigate={autoNavigate}
          setAutoNavigate={setAutoNavigate}
          isGoalSectionEditable={isGoalSectionEditable}
        />
      </Container>
    </ReviewProvider>
  ) : null;
};

export default ReviewTemplatePreview;

const Container = styled.div`
  padding: 2rem 3rem;
`;
